export default {
    "Language": "Sprache",
    "UserName": "Benutzername",
    "Email": "E-Mail",
    "PassWord": "Passwort",
    "Login": "Anmelden",
    "SignUp": "Registrieren",
    "Welcome": "Willkommen",
    "ForgotPasswrod": "Passwort vergessen?",
    "NoAccount": "Sie haben noch kein Konto? Registrieren",
    "ServerError": "Systemfehler",
    "ReadAgree": "Ich habe gelesen und stimme zu",
    "And": "und",
    "ScanQRCodeDownloadAPP": "Bitte scannen Sie den folgenden QR-Code, um die App herunterzuladen und Konten zu erstellen",
    "EmailEmpty": "Das E-Mail-Konto darf nicht leer sein",
    "PasswordEmpty": "Das Passwort darf nicht leer sein",
    "PleaseSelect": "Bitte auswählen",
    "Logout": "Abmelden",
    "CreateCompany": "Firma erstellen",
    "CompanyName": "Firmenname *",
    "Confirm": "Bestätigen",
    "Cancel": "Abbrechen",
    "CompanyNameEmpty": "Der Firmenname darf nicht leer sein",
    "CreatedSuccessfully": "Erfolgreich erstellt",
    "CompanyDashboard": "Firmen-Dashboard",
    "Sites": "Standort",
    "CompanyAdmin": "Firmenadministrator",
    "PurchaseRecord": "Kaufnachweis",
    "MoreDetail": "Weitere Details",
    "CreateSite": "Neuer Standort",
    "Admin": "Administratoren",
    "AdminAccess": "Benutzer verwalten, die Administratorzugang zu dieser Firma haben",
    "Licenses": "Lizenzen",
    "PaymentInvioces": "Sehen Sie Ihre Zahlungshistorie und verwalten Sie Unternehmensrechnungen",
    "SiteName": "Standortname *",
    "SiteAddress": "Adresse *",
    "Add": "Hinzufügen",
    "Edit": "Bearbeiten",
    "Delete": "Löschen",
    "DeleteSiteTitle": "Sind Sie sicher, dass Sie den Standort löschen möchten?",
    "NoData": "Keine Daten",
    "SiteNameEmpty": "Der Standortname darf nicht leer sein",
    "SiteAddressEmpty": "Die Standortadresse darf nicht leer sein",
    "UpdateSuccessfully": "Erfolgreich aktualisiert",
    "DeleteSuccessfully": "Erfolgreich gelöscht",
    "AddAdmin": "Administrator hinzufügen",
    "AddCompanyAdmin": "Firmenadministrator hinzufügen",
    "RegisteredAccount": "Bitte geben Sie das registrierte Konto ein",
    "EmailAccount": "E-Mail-Konto *",
    "AdminCompanyRole": "Benutzerrolle Firmenadministrator",
    "ManagesSitesAdmins": "Verwaltet alle Standorte und Standortadministratoren.",
    "AccessBilling": "Nimmt Zahlungen vor und hat Zugriff auf Rechnungsinformationen.",
    "Serach": "Suche",
    "UserInfo": "Benutzerinformationen",
    "UserAccount": "Benutzerkonto",
    "Nickname": "Spitzname:",
    "FirstName": "Vorname *",
    "Surname": "Nachname",
    "SureDelete": "Sind Sie sicher, dass Sie löschen möchten?",
    "NoRecord": "Kein Eintrag",
    "AdminName": "Administratorname",
    "Account": "Konto",
    "Role": "Rolle",
    "CreateDate": "Erstellungsdatum",
    "EmailEmpty": "Das E-Mail-Konto darf nicht leer sein",
    "EmailIncorrect": "Das E-Mail-Konto existiert nicht oder ist falsch",
    "FirstNameEmpty": "Der Vorname darf nicht leer sein!",
    "SurnameNameEmpty": "Der Nachname darf nicht leer sein!",
    "Save": "Speichern",
    "StartTime": "Startzeit",
    "EndTime": "Endzeit",
    "NoPurchaseRecord": "Es gibt keinen Kaufnachweis!",
    "LicenseName": "Lizenzname",
    "Quantity": "Menge",
    "Amount": "Betrag",
    "StartTimeEmptye": "Die Startzeit darf nicht leer sein",
    "EndTimeEmptye": "Die Endzeit darf nicht leer sein",
    "StartTimeLaterEndTime": "Die Startzeit darf nicht später als die Endzeit sein",
    "SiteDashboard": "Standort-Dashboard",
    "Blocks": "Blöcke",
    "Panels": "Geräte",
    "SiteUsers": "Standortbenutzer",
    "EventRecords": "Ereignisprotokolle",
    "AssessLog": "Zugriffsprotokoll",
    "SiteLicenses": "Standortlizenzen",
    "Payments": "Zahlungen",
    "MyProfile": "Mein Profil",
    "AddBlocks": "Blöcke hinzufügen",
    "BlocksOnSite": "Blöcke am Standort",
    "SeeAllPanels": "Alle Geräte anzeigen",
    "AddPanels": "Panels hinzufügen",
    "AddedDecices": "Hinzugefügte Geräte",
    "Normal": "Normal",
    "NeedConfigration": "Konfiguration erforderlich",
    "CheckFail": "Fehler",
    "Offline": "Offline",
    "SeeAllUsers": "Alle Benutzer anzeigen",
    "Users": "Benutzer",
    "AddUsers": "Benutzer hinzufügen",
    "AddedUser": "Hinzugefügter Benutzer",
    "LicensesNormal": "Aktive Lizenzen",
    "LicensesExpired": "Abgelaufene Lizenzen",
    "NotOpened": "Nicht geöffnet",
    "NotAccepted": "Nicht akzeptiert",
    "BuyLiences": "Lizenzen kaufen",
    "RemainingQuantit": "Verbleibende Menge",
    "BuyMore": "Mehr kaufen",
    "BlocksName": "Blockname *",
    "BlocksNumber": "Blocknummer *",
    "DeleteBlock": "Block löschen",
    "CreateBlock": "Neuen Block erstellen",
    "NoBlock": "Keine vorhandenen Blöcke, bitte zuerst Blöcke hinzufügen!",
    "PanelsQuantity": "Panelanzahl",
    "UsersQuantity": "Benutzeranzahl",
    "CreateSites": "Neue Standorte erstellen",
    "BlocksNameEmpty": "Der Blockname darf nicht leer sein",
    "BlocksNumberEmpty": "Die Blocknummer darf nicht leer sein",
    "BlockDetail": "Blockdetails",
    "DeletePanel": "Sind Sie sicher, dass Sie das Gerät vom Campus entfernen möchten? Nach dem Löschen verschwindet es automatisch aus dem relevanten Benutzerkonto.",
    "NoPanel": "Keine Informationen, bitte zuerst Geräte hinzufügen!",
    "PanelsId": "Panel-ID",
    "PanelsName": "Panelname",
    "PanelsStatus": "Panelstatus",
    "DeleteUser": "Nachdem die Daten gelöscht wurden, wird der Benutzer (und der geteilte Benutzer) entbunden und kann den Eingangsservice des Parks nicht mehr nutzen; Der Löschvorgang kann nicht rückgängig gemacht werden.",
    "NoUser": "Keine Benutzerinformationen, bitte Benutzer hinzufügen.",
    "HouseNumber": "Wohnungsnummer",
    "UserRole": "Benutzerrolle",
    "UserStatus": "Benutzerstatus",
    "ServiceStatus": "Lizenzstatus",
    "ServicesRemaining": "Verbleibende Dauer",
    "BlocksDetail": "Blockdetails",
    "Invalid": "Ungültig",
    "Ready": "Online",
    "NeedVerification": "Überprüfung erforderlich",
    "NotResponding": "Reagiert nicht",
    "Accepted": "Akzeptiert",
    "Refuse": "Abgelehnt",
    "NotBound": "Nicht gebunden",
    "NotEnabled": "Nicht aktiviert",
    "InUse": "In Benutzung",
    "End": "Beendet",
    "Days": "Tage",
    "CreatePanels": "Neues Panel erstellen",
    "PanelsSerialNumber": "Panel-Seriennummer",
    "NotFndSerial": "Wenn Sie die Seriennummer nicht finden können, klicken Sie bitte hier",
    "PanelsSecurityCode": "Panel-Sicherheitscode",
    "PanelsSerialCode": "Wenn Sie den Sicherheitscode nicht finden können, klicken Sie bitte hier",
    "Or": "Oder",
    "RolePermission": "Rollenberechtigungssteuerung",
    "SiteUser": "Standortbenutzer",
    "SiteEmployee": "Standortmitarbeiter",
    "SiteOther": "Sonstiger Standort",
    "Status": "Status",
    "PanelsSerialNumberEmpty": "Die Panel-Seriennummer darf nicht leer sein",
    "PanelsSecurityNumberEmpty": "Der Sicherheitscode des Panels darf nicht leer sein",
    "PanelsNameEmpty": "Der Panelname darf nicht leer sein",
    "SiteOrBlocksEmpty": "Der Standort oder die Blöcke dürfen nicht leer sein",
    "AddSuccessful": "Erfolgreich hinzugefügt",
    "RevalidateDevice": "Gerät erneut validieren",
    "PanelsDetail": "Paneldetails",
    "AccessControl": "Zugangskontrolle",
    "DevicesMode": "Gerätemodus",
    "SerialNumber": "Seriennummer",
    "FirmwareVersion": "Firmware-Version",
    "Revalidate": "Erneut validieren",
    "UpdateFailure": "Aktualisierung fehlgeschlagen",
    "AddSiteUser": "Standortbenutzer hinzufügen",
    "AddingUser": "Benutzer wird hinzugefügt, bitte warten...",
    "UserEmail": "Benutzer-E-Mail",
    "ActivationMethod": "Aktivierungsmethode",
    "ChooseActivationMethod": "Wählen Sie aus, wie der Service für den Benutzer aktiviert werden soll.",
    "AvailableActivationCodes": "Verfügbare Aktivierungscodes",
    "AddUserSuccess": "Benutzer erfolgreich hinzugefügt!",
    "UserHasJoined": "Benutzer ist beigetreten",
    "UserServiceActivated": "Der Dienst des Benutzers wurde aktiviert!",
    "ActivationCode": "Aktivierungscode",
    "UserConfrmation": "Benutzerbestätigung",
    "ConfirmationEmail": "Eine Bestätigungs-E-Mail wurde an den Benutzer gesendet. Bitte benachrichtigen Sie den Benutzer, die nachfolgende Aktion gemäß der E-Mail-Anweisung abzuschließen.",
    "ScanQRCode": "Oder scannen Sie bitte den QR-Code mit der App, um beizutreten!",
    "ServiceActivation": "Serviceaktivierung",
    "Total": "Gesamt",
    "Select": "Auswählen",
    "Activation": "Aktivierung",
    "UserServiceActivation": "Benutzer-Serviceaktivierung, bitte warten...",
    "ConsumedActivate": "Blätter werden verbraucht, um die folgenden Benutzer zu aktivieren",
    "BindingUser": "Benutzer binden",
    "BindingUserWait": "Benutzer wird gebunden, bitte warten...",
    "UnbindingUser": "Benutzerbindung aufheben",
    "UnbindingUserDesc": "Nach dem Entbinden kann der Benutzer den Eingangsmaschinenservice der Anlage nicht mehr nutzen.",
    "ActivationTypeOne": "Benutzer kaufen und öffnen selbstständig",
    "ActivationTypeTwo": "Aktivierungscode zuweisen",
    "ActivationTypeThree": "Aktivierungscode eingeben",
    "Years": "Jahre",
    "Year": "Jahr",
    "Months": "Monate",
    "Month": "Monat",
    "Day": "Tag",
    "UserEmailEmpty": "Die Benutzer-E-Mail darf nicht leer sein",
    "HouseNumberEmpty": "Die Wohnungsnummer darf nicht leer sein",
    "UserRoleEmpty": "Die Benutzerrolle darf nicht leer sein",
    "ActivationMethodEmpty": "Die Aktivierungsmethode darf nicht leer sein",
    "SelectAtLeastOne": "Bitte wählen Sie mindestens ein Kriterium zur Suche aus",
    "SelectAtLeastActivate": "Bitte wählen Sie mindestens einen Benutzer zur Aktivierung aus",
    "SelectLicense": "Bitte wählen Sie eine Lizenz aus",
    "InsufficientLicense": "Unzureichende Lizenzmenge",
    "ActivationSuccessful": "Erfolgreiche Aktivierung",
    "BindingSuccessful": "Erfolgreiche Bindung",
    "UnbindSuccessful": "Erfolgreiches Entbinden",
    "UserDetail": "Benutzerdetails",
    "Devices": "Geräte",
    "UserSetting": "Benutzereinstellungen",
    "Augment": "Erweitern",
    "DeviceName": "Gerätename",
    "DeviceId": "Geräte-ID",
    "AccessRights": "Zugriffsrechte",
    "AssessStatus": "Zugriffsstatus",
    "SiteDevices": "Standortgeräte",
    "Preview": "Vorschau",
    "PreviewEnd": "Vorschau,",
    "Unlock": "Entsperren",
    "UnlockEnd": "Entsperren,",
    "Call": "Anruf",
    "CallEnd": "Anruf,",
    "NoAssessLog": "Kein Zugriffsprotokoll aufgezeichnet!",
    "OperationModule": "Betriebsmodul",
    "OperationContent": "Betriebsinhalt",
    "Company": "Unternehmen",
    "UpdateSite": "Standort aktualisieren",
    "DeleteSite": "Standort löschen",
    "UpdateBlock": "Block aktualisieren",
    "DeleteBlock": "Block löschen",
    "BindingPanels": "Panels binden",
    "UpdatePanels": "Panels aktualisieren",
    "UnbindingPanels": "Panels entbinden",
    "UpdateUser": "Benutzer aktualisieren",
    "DeleteUserLog": "Benutzer löschen",
    "PurchasingLicence": "Lizenzkauf",
    "UpdateCompanyAdmin": "Unternehmensadministrator aktualisieren",
    "DeleteCompanyAdmin": "Unternehmensadministrator löschen",
    "UserLogin": "Benutzeranmeldung",
    "RocessingPayment": "Zahlungsdaten werden verarbeitet, bitte warten...",
    "PaySuccess": "Zahlung erfolgreich",
    "PayFail": "Zahlung fehlgeschlagen",
    "Person": "Wohnung",
    "BuyQuantity": "Menge kaufen",
    "CustomQuantity": "Benutzerdefinierte Menge",
    "PayPlatfrom": "Zahlungsplattform",
    "PayAmount": "Zahlungsbetrag",
    "Pay": "Bezahlen",
    "ServiceLicenses": "Service-Lizenzen",
    "ActivationRecords": "Aktivierungsprotokolle",
    "NoLicense": "Keine Lizenz verfügbar, bitte kaufen!",
    "LicensesName": "Lizenzname",
    "ActivationKey": "Code",
    "SelectLicensePurchase": "Bitte wählen Sie die Lizenz aus, die Sie kaufen möchten",
    "PaymentFailure": "Bestellungszahlung fehlgeschlagen",
    "BuyNow": "Jetzt kaufen",
    "OrderNo": "Bestellnummer",
    "OrderStatus": "Bestellstatus",
    "Date": "Datum",
    "OrderName": "Bestellname",
    "OrderTime": "Bestellzeit",
    "PayTime": "Zahlungszeit",
    "Pending": "Ausstehend",
    "Completed": "Abgeschlossen",
    "Expired": "Abgelaufen",
    "UseAPPScanQRCode": "Nutzen Sie die QvHome APP, um den Code zu scannen und den Service zu nutzen",
    "RequestParameterError": "Fehlerhafter Anfrageparameter",
    "InvalidRequest": "Ungültige Anfrage",
    "RequestTimeou": "Anfragezeitüberschreitung",
    "UserNoLogin": "Benutzer nicht eingeloggt",
    "RemoteServiceNotFound": "Remote-Dienst nicht gefunden",
    "ErrorCallingRemoteService": "Fehler beim Aufrufen des Remote-Dienstes",
    "DataNotFound": "Daten nicht gefunden",
    "RequestsTooFrequent": "Anfragen sind zu häufig",
    "NoOperationPermission": "Keine Berechtigung zur Ausführung der Aktion",
    "DataAlreadyExists": "Daten existieren bereits",
    "UserNamePassword": "Benutzername und Passwort stimmen nicht überein",
    "AccountAlreadyExists": "Konto existiert bereits",
    "VerificationCodeError": "Fehlerhafter Bestätigungscode",
    "UnknownError": "Unbekannter Fehler",
    "NoAuthorizedCompany": "Kein autorisiertes Unternehmen gefunden",
    "NoAuthorizedSite": "Kein autorisierter Standort gefunden",
    "UserNotJoinHouse": "Der Benutzer ist nicht dem Haus beigetreten",
    "CloudPushNotEnabled": "Der Cloud-Push-Dienst ist nicht aktiviert",
    "DeviceBound": "Gerät gebunden",
    "HouseNumberAlreadyExists": "Die Wohnungsnummer existiert bereits",
    "HouseNumberNotExists": "Die Wohnungsnummer existiert nicht",
    "BlockNumberNotExists": "Turmnummer existiert nicht",
    "DeviceUnbound": "Gerät entbunden",
    "InventoryShortag": "Bestandsmangel",
    "PaymentOrderVerificationFailed": "Überprüfung der Zahlungsbestellung fehlgeschlagen",
    "PaymentFailed": "Zahlung fehlgeschlagen",
    "NoPackageFound": "Kein Paketöffnungsauftrag gefunden",
    "NoAvailablePackages": "Keine verfügbaren Pakete gefunden",
    "PackageHasModified": "Das Paket wurde geändert",
    "ChangedOnce": "Das Paket kann nur einmal innerhalb von 7 Tagen geändert werden",
    "OrdersNonRefundable": "Bestellungen sind nicht erstattungsfähig",
    "PaymentConfigurationNotFound": "Zahlungskonfiguration nicht gefunden",
    "OrderRefundFailed": "Bestellrückerstattung fehlgeschlagen",
    "PackageLessThanOneDay": "Weniger als ein Tag verbleibt im Paket",
    "DataSaveError": "Fehler beim Speichern der Daten",
    "DataUpdateError": "Fehler beim Aktualisieren der Daten",
    "DataDeleteError": "Fehler beim Löschen der Daten",
    "CompanyAdminExistsSite": "Der Unternehmensadministrator existiert bereits auf der Website",
    "NotAllowDeleteOurself": "Es ist nicht erlaubt, sich selbst zu löschen",
    "ProductNotSupportBind": "Dieses Produkt unterstützt keine Bindung",
    "DeviceSecurityCheckFail": "Die Überprüfung des Gerätesicherheitscodes ist fehlgeschlagen",
    "DeviceNotSupportServer": "Das Gerät unterstützt diesen Dienst nicht",
    "OemConfigNotFount": "OEM-Konfiguration nicht gefunden",
    "EmailSendFail": "E-Mail-Versand fehlgeschlagen",
    "UserAccountNotFound": "Benutzerkonto nicht gefunden",
    "CompanyDataNotFond": "Unternehmensdaten nicht gefunden",
    "DevicesDataNotFond": "Gerätedaten nicht gefunden",
    "DevicesNoPermission": "Gerät hat keine Berechtigung",
    "UserNotBindingHouse": "Benutzer ist nicht mit einem Haus verbunden",
    "PkgNotAvailable": "Paket nicht verfügbar",
    "UserNotFond": "Benutzer nicht gefunden",
    "AuthNotFound": "Authentifizierung nicht gefunden",
    "IotUnlockFail": "Entsperrung fehlgeschlagen",
    "UserMismatchOem": "Der Benutzer-OEM stimmt nicht überein",
    "AlarmCancelShareFail": "Fehler beim Abbrechen der Alarmfreigabe",
    "AlarmUnbindFail": "Fehler beim Entbinden des Alarms",
    "AlarmShareFail": "Fehler bei der Alarmfreigabe",
    "InvitationInvalid": "Einladung ungültig",
    "UnallocatedLicense": "Nicht zugewiesene Lizenz",
    "HaveBeenUsed": "Wurde bereits verwendet",
    "CompanyNameLimit": "Der Firmenname muss 1 bis 30 Zeichen enthalten",
    "SiteNotFound": "Standort nicht gefunden",
    "SiteNameLimit": "Der Standortname muss 1 bis 30 Zeichen enthalten",
    "EmailFormatLimit": "Das E-Mail-Format ist falsch",
    "FirstNameLimit": "Der Vorname muss zwischen 1 und 20 Zeichen lang sein",
    "SurnameLimit": "Der Nachname muss zwischen 1 und 20 Zeichen lang sein",
    "PersonalInfo": "Persönliche Informationen",
    "BlockNameLimit": "Der Blockname muss 1 bis 30 Zeichen enthalten",
    "BlockNumberLimit": "Die Blocknummer muss 1 bis 30 Zeichen enthalten",
    "DeviceSerialLimit": "Die Seriennummer der Panels muss 1 bis 20 Zeichen enthalten",
    "DeviceSecurityCodeLimit": "Der Sicherheitscode des Panels muss 1 bis 64 Zeichen enthalten",
    "DeviceNameLimit": "Der Panelname muss 1 bis 30 Zeichen enthalten",
    "HouseNumberLimit": "Die Wohnungsnummer muss 1 bis 20 Zeichen enthalten",
    "LoginExpired": "Benutzeranmeldung abgelaufen, bitte erneut anmelden",
    "ServicesRemainingLimit": "Der verbleibende Servicetag-Wert kann nur 0 oder eine positive ganze Zahl zwischen 0 und 8 Ziffern sein",
    "LastAdminNotDelete": "Der letzte Administrator kann nicht gelöscht werden",
    "CanNotUpdateOwnRoles": "Sie können Ihre Administratorrolle nicht aktualisieren",
    "UserUnbindingFailed": "Fehler beim Entbinden des Benutzers",
    "AdminAccountLimit": "Admin-Konten müssen zwischen 1 und 100 Zeichen enthalten",
    "UserNameLimit": "Der Benutzername muss zwischen 1 und 30 Zeichen enthalten",
    "OrderNoLimit": "Die Bestellnummer muss zwischen 1 und 64 Zeichen enthalten",
    "licensesNumLimit": "Es dürfen nur positive ganze Zahlen zwischen 1 und 999 eingegeben werden",
    "BlockNumberNotZero": "Die Blocknummer darf nicht 0 sein",
    "CompanyOverLimit": "Die Anzahl der erstellten Unternehmen überschreitet das Limit",
    "SiteOverLimit": "Die Anzahl der erstellten Standorte überschreitet das Limit",
    "ApartmentOverLimit": "Die Anzahl der erstellten Wohnungen überschreitet das Limit",
    "Notice": "Mitteilungen",
    "PanelLog": "Panel-Protokoll",
    "OperationLog": "Betriebsprotokoll",
    "Panel": "Panel",
    "CallHasBeenAnswered": "Der Anruf wurde beantwortet",
    "CallNotAnswered": "Anruf nicht beantwortet",
    "Time": "Zeit",
    "Default": "Standard",
    "QRCodeUnlock": "Entsperrung per QR-Code",
    "PasswordUnlock": "Entsperrpasswort",
    "IndoorMachineUnlock": "Entsperren über Innenmaschine",
    "AppUnlock": "APP-Entsperrung",
    "RfCard": "RF-Karte",
    "ExitButton": "Exit-Tasten-Entsperrung",
    "DtmfUnlock": "DTMF-Entsperrung",
    "GoogleUnlock": "Google-Entsperrung",
    "AlexaUnlock": "Alexa-Entsperrung",
    "FaceUnlock": "Gesichtserkennung-Entsperrung",
    "Success": "Erfolgreich",
    "Failed": "Fehlgeschlagen",
    "Loading": "Laden",
    "ApartmentNumber": "Wohnungsnummer",
    "Image": "Bild",
    "CallLog": "Anrufprotokoll",
    "AccessLog": "Zugriffsprotokoll",
    "Export": "Exportieren",
    "UnlockType": "Entsperrtyp",
    "NoExportData": "Keine Exportdaten!",
    "ExportSuccess": "Erfolgreich exportiert",
    "Return": "Zurück",
    "APPNotice": "App-Benachrichtigung",
    "DeviceNotice": "Gerätebenachrichtigung",
    "Refresh": "Aktualisieren",
    "AddNotice": "Benachrichtigung hinzufügen",
    "Withdraw": "Zurückziehen",
    "Release": "Veröffentlichen",
    "More": "Mehr",
    "Broadcast": "Broadcast",
    "ChooseDevice": "Gerät auswählen",
    "ReceptionDevice": "Empfangsgerät:",
    "SelectedDeviceNumber": "Ausgewählte Geräteanzahl:",
    "Title": "Titel:",
    "DigitsLimit": "Die Titellänge muss 1-50 Zeichen betragen",
    "TitlePicture": "Titelbild:",
    "PictureRatio": "Hinweis: Wir empfehlen das Hochladen eines Bildes mit einem 9:16-Seitenverhältnis",
    "TimeRange": "Zeitraum:",
    "CreateNotice": "Benachrichtigung erstellen",
    "Update": "Aktualisieren",
    "Modify": "Ändern",
    "Content": "Inhalt",
    "ReleaseStatus": "Veröffentlichungsstatus",
    "Released": "Veröffentlicht",
    "TitleTable": "Titel",
    "Draft": "Entwurf",
    "TitlePictureEmpty": "Bitte fügen Sie das Titelbild hinzu",
    "DeleteFailed": "Löschen fehlgeschlagen",
    "ImageUploadFailed": "Bild-Upload fehlgeschlagen",
    "PleaseSelectDevice": "Bitte Gerät auswählen",
    "MaximumDevicesSelected": "Es können maximal 10 Geräte ausgewählt werden",
    "SuccessfulWithdraw": "Erfolgreich zurückgezogen",
    "SuccessfulRelease": "Erfolgreich veröffentlicht",
    "RemoveDeviceNotice": "Gerätebenachrichtigung entfernen",
    "WithdrawDeviceNotice": "Gerätebenachrichtigung zurückziehen",
    "ReleaseDeviceNotice": "Gerätebenachrichtigung veröffentlichen",
    "UpdateNotice": "Benachrichtigung aktualisieren",
    "UploadImagejpg": "Bitte laden Sie ein Bild mit der .jpg-Erweiterung hoch!",
    "ConfirmPassword": "Passwort bestätigen",
    "Prompt": "Hinweis",
    "AutoJumpLogin": "Es wird automatisch nach 0 Sekunden zur Anmeldeseite weitergeleitet. Klicken Sie auf Bestätigen, um sofort weiterzuleiten.",
    "RegisteredSuccess": "Erfolgreich registriert",
    "PasswordChangedSuccess": "Passwort erfolgreich geändert",
    "SendVerificationCode": "Verifizierungscode senden",
    "ResendSeconds": "Erneut senden in 0 Sekunden",
    "VerificationCode": "Verifizierungscode",
    "PasswordFormatLimit": "Passwort muss 8-16 Zeichen lang sein und Groß- sowie Kleinbuchstaben, Zahlen und Sonderzeichen enthalten.",
    "ChangePassword": "Passwort ändern",
    "NextStep": "Weiter",
    "EnterVerificationCode": "Bitte geben Sie den Verifizierungscode ein",
    "EnterCorrectEmailFormat": "Bitte geben Sie das korrekte E-Mail-Format ein",
    "PasswordLess": "Das Passwort muss mindestens 8 Zeichen lang sein",
    "PasswordLarger": "Das Passwort darf nicht länger als 16 Zeichen sein",
    "PasswordNotRules": "Das Passwort entspricht nicht den Regeln",
    "EntePasswordAgain": "Bitte geben Sie das Passwort erneut ein",
    "PasswordNotMatch": "Das Passwort und die Bestätigung stimmen nicht überein",
    "VerificationCodeSentSuccess": "Der Verifizierungscode wurde erfolgreich gesendet",
    "UrlExpired": "URL ist abgelaufen",
    "EmailAccountExists": "E-Mail-Konto existiert bereits",
    "VerificationCodeIncorrect": "Der Verifizierungscode ist falsch",
    "VerificationCodeInvalid": "Der Verifizierungscode ist ungültig",
    "TermsCondition": "Nutzungsbedingungen",
    "PrivacyPolicy": "Datenschutzrichtlinie",
    "CheckReadAgree": "Bitte bestätigen Sie, dass Sie die Nutzungsbedingungen und die Datenschutzrichtlinie gelesen und akzeptiert haben",
    "DisplayName": "Anzeigename",
    "AccountSettings": "Kontoeinstellungen",
    "Remark": "Bemerkung",
    "Server": "Server",
    "Port": "Port",
    "TCPOrUDP": "TCP/UDP",
    "DTMFSetting": "DTMF-Einstellung",
    "Lock1": "Schloss 1",
    "Lock2": "Schloss 2",
    "Talk": "Sprechen",
    "DisplayNameEmpty": "Der Anzeigename muss 1 bis 64 Zeichen enthalten",
    "RemarkEmpty": "Die Bemerkung muss 1 bis 64 Zeichen enthalten",
    "ServerEmpty": "Der Server muss 1 bis 64 Zeichen enthalten",
    "PortEmpty": "Der Port muss 1 bis 20 Zeichen enthalten",
    "TCPOrUDPEmpty": "TCP/UDP darf nicht leer sein",
    "AccountEmpty": "Das Konto muss 1 bis 64 Zeichen enthalten",
    "Lock1Empty": "Schloss 1 muss 1 bis 20 Zeichen enthalten",
    "Lock2Empty": "Schloss 2 muss 1 bis 20 Zeichen enthalten",
    "TalkEmpty": "Sprechen muss 1 bis 20 Zeichen enthalten",
    "NoSip": "Keine Informationen, bitte zuerst einen neuen SIP-Server hinzufügen!",
    "PasswordLimit": "Passwort muss 1 bis 64 Zeichen enthalten",
    "NoGuard": "Keine Informationen, bitte zuerst einen neuen Wachmann hinzufügen!",
    "SipSettings": "SIP-Einstellungen",
    "GuardSettings": "Wacheinstellungen",
    "ConfirmDelSip": "Löschen der SIP-Einstellung bestätigen?",
    "GuardNameLimit": "Der Wachmann-Name muss 1 bis 20 Zeichen enthalten",
    "AddressEmpty": "Die Adresse darf nicht leer sein",
    "GuardName": "Wachmann-Name",
    "CreateGuard": "Neuen Wachmann erstellen",
    "EditGuard": "Wachmann bearbeiten",
    "Address": "Adresse",
    "ConfirmDelGuard": "Löschen des Wachmanns bestätigen?",
    "AddSipServer": "Neuen SIP-Server hinzufügen",
    "ConfirmUnbindPanel": "Entbindung des Panels bestätigen?",
    "PleaseSelectPanels": "Bitte Panels auswählen",
    "ServerConfigEmpty": "Die Serverkonfiguration darf nicht leer sein",
    "Mode": "Modus",
    "SeverMode": "Servermodus",
    "P2PMode": "P2P-Modus",
    "ServerConfig": "Serverkonfiguration",
    "TargetSip": "Ziel-SIP",
    "P2PConfig": "P2P-Konfiguration",
    "CreateDeviceConfig": "Gerätekonfiguration erstellen",
    "UpdateDeviceConfig": "Gerätekonfiguration aktualisieren",
    "DeleteDeviceConfig": "Gerätekonfiguration löschen",
    "CreateUserHouseConfig": "Benutzereinstellungen für Standort erstellen",
    "UpdateUserHouseConfig": "Benutzereinstellungen für Standort aktualisieren",
    "DeleteUserHouseConfig": "Benutzereinstellungen für Standort löschen",
    "CreateDeviceGuardConfig": "Wachmann-Konfiguration für Gerät erstellen",
    "UpdateDeviceGuardConfig": "Wachmann-Konfiguration für Gerät aktualisieren",
    "DeleteDeviceGuardConfig": "Wachmann-Konfiguration für Gerät löschen",
    "CreateDeviceNotice": "Gerätebenachrichtigung erstellen",
    "UpdateDeviceNotice": "Gerätebenachrichtigung aktualisieren",
    "DeleteDeviceNotice": "Gerätebenachrichtigung löschen",
    "DeviceNoticeRelease": "Gerätebenachrichtigung veröffentlichen",
    "DeviceNoticeWithdraw": "Gerätebenachrichtigung zurückziehen",
    "EnterTitle": "Bitte Titel eingeben",
    "Unused": "Nicht verwenden",
    "ServerName": "Servername",
    "DeviceDelete": "Gerät löschen",
    "PrivateMessage": "Private Nachricht",
    "Profile": "Profil",
    "EnableProfile": "Profil aktivieren",
    "DisableProfile": "Profil deaktivieren",
    "WhetherEnableProfile": "Sind Profile aktiviert?",
    "WhetherDisableProfile": "Soll das Profil deaktiviert werden?",
    "PleaseSelectUser": "Bitte Benutzer auswählen",
    "MaximumUserSelected": "Es können maximal 10 Benutzer ausgewählt werden",
    "SelectedUserNumber": "Anzahl ausgewählter Benutzer：",
    "RemoveAppNotice": "App-Benachrichtigung entfernen",
    "WithdrawAppNotice": "App-Benachrichtigung zurückziehen",
    "ReleaseAppNotice": "App-Benachrichtigung veröffentlichen",
    "TamperLog": "Manipulationsprotokoll",
    "ReleaseType": "Veröffentlichungstyp",
    "ReadNumber": "Leseanzahl",
    "MaximumCharacterLimit": "Der Inhalt darf maximal 1 Zeichen enthalten",
    "MaximumNoticeReachLimit": "Die maximale Anzahl an Ankündigungen wurde erreicht",
    "UploadedImageLimit": "Die hochgeladene Bildgröße darf 2 MB nicht überschreiten!",
    "ContentCannotEmpty": "Der Inhalt darf nicht leer sein!",
    "EndTimeGreateCurrentTime": "Die Endzeit muss größer als die aktuelle Zeit sein!",
    "AccountNotExist": "Konto existiert nicht",
    "PasswordError": "Passwort ist falsch",
    "PictureRatioApp": "Hinweis: Wir empfehlen das Hochladen eines Bildes im 16:9-Format",
    "Name": "Name",
    "NameCannotEmpty": "Namen müssen zwischen 1-64 Zeichen lang sein",
    "CardNumber": "Vollständige Kartennummer",
    "CardNumberEmpty": "Die vollständige Kartennummer darf nicht leer sein",
    "UnlockOption": "Freischaltoption",
    "UnlockOptionEmpty": "Die Freischaltoption darf nicht leer sein",
    "Limited": "Begrenzt",
    "LimitedEmpty": "Das Limit darf nicht leer sein",
    "CardSettings": "Karteneinstellungen",
    "LimitedUse": "Begrenzte Nutzung",
    "ValidityTime": "Gültigkeitszeitraum",
    "PanelSync": "Gerätesynchronisierung",
    "AddCardNumber": "Kartennummer hinzufügen",
    "NumbeOfUses": "Anzahl der Verwendungen",
    "Unlinmited": "Unbegrenzt",
    "Forever": "Für immer",
    "EditCardNumber": "Kartennummer bearbeiten",
    "ConfirmDeleteCard": "Löschen der Karteneinstellungen bestätigen?",
    "NotApplied": "Nicht angewendet",
    "ApplicationComplete": "Anwendung abgeschlossen",
    "DataValidationFailed": "Datenvalidierung fehlgeschlagen",
    "TypesNotSupported": "Nicht unterstützte Typen",
    "DeviceLimitedInput": "Gerätebegrenzter Eingabefehler",
    "CCTVSettings": "CCTV-Einstellungen",
    "IPRTSPUrl": "IP/RTSP-URL",
    "Stream": "Stream",
    "DeletingCCTV": "Löschen der CCTV-Konfiguration bestätigen?",
    "MainStream": "Hauptstream",
    "SubStream": "Substream",
    "AddCamera": "Kamera hinzufügen",
    "EditCamera": "Kamera bearbeiten",
    "IPRTSPUrlEmpty": "Die IP/RTSP-URL darf nicht leer sein",
    "UsernameEmpty": "Der Benutzername darf nicht leer sein",
    "StreamEmpty": "Der Stream darf nicht leer sein",
    "DeviceVersion": "Geräteversion",
    "CardNumberExists": "Die Kartennummer existiert bereits",
    "AddCard": "Karte hinzufügen",
    "FacilityCodeCardNumber": "Facility Code & Kartennummer",
    "PleasePlacePard": "Bitte legen Sie eine Karte auf den Leser",
    "ReaderNotDetected": "Lesegerät nicht erkannt. Bitte prüfen Sie die Treiberinstallation oder Kabelverbindung!",
    "DownloadDriver": "Treiber herunterladen",
    "TestDriver": "Treiber testen",
    "ChooseDriverDownload": "Bitte wählen Sie den entsprechenden Treiber zum Download basierend auf Ihrem PC-System",
    "RestartTest": "Neustart zum Testen",
    "FacilityCode": "Facility Code",
    "FullCardNumLimit": "Die eingegebene Kartennummer ist ungültig. Bitte erneut eingeben",
    "FacilityCodeCardNumberEmpty": "Facility Code & Kartennummer dürfen nicht leer sein",
    "FacilityCodeEmpty": "Der Facility Code muss numerisch sein und darf 255 nicht überschreiten",
    "FacilityCardNumberEmpty": "Die Kartennummer muss eine Zahl sein und darf 65535 nicht überschreiten",
    "ManualInput": "Manuelle Eingabe",
    "Reader": "Lesegerät",
    "SiteList": "Standortliste",
    "ManageSelectedSite": "Ausgewählten Standort verwalten",
    "ManageSelectEmpty": "Bitte wählen Sie den zu verwaltenden Standort aus",
    "AdminAccountExists": "Administrator-Konto existiert bereits",
    "CompanyNameOnly": "Firmenname",
    "DeleteCompanyLimit": "Bitte löschen Sie alle Standorte unter dem Unternehmen, bevor Sie das Unternehmen löschen",
    "CompanyList": "Firmenliste",
    "Rename": "Umbenennen",
    "InputNewCompanyName": "Bitte geben Sie einen neuen Firmennamen ein",
    "SureDeleteCompany": "Sind Sie sicher, dass Sie das Unternehmen löschen möchten?",
    "SelectPayPlatform": "Bitte wählen Sie die Zahlungsplattform",
    "LimitReached": "Das Limit wurde erreicht",
    "LimitPassword": "Die maximale Passwortlänge darf 64 Zeichen nicht überschreiten",
    "LimitUserName": "Die maximale Länge eines Benutzernamens darf 64 Zeichen nicht überschreiten",
    "LimitUnlockNum": "Die maximale Anzahl von Einschränkungen darf 100 nicht überschreiten",
    "LimitHouseNumber": "Wohnungsnummern dürfen nur Buchstaben und Zahlen enthalten und müssen größer als 0 sein, wenn sie rein numerisch sind",
    "LimitBlockNumber": "Die Blocknummer darf nur numerisch sein und muss größer als 0 sein",
    "CardNumberWrong": "Die Kartennummer ist falsch",
    "UsersReachLimit": "Hinzufügen von Benutzern hat das Limit erreicht",
    "DeviceReachLimit": "Hinzufügen von Geräten hat das Limit erreicht",
    "UserMessages": "Benutzernachrichten",
    "MessagesPending": "Ausstehend",
    "BeingProcessed": "In Bearbeitung",
    "MessagesEnd": "Beendet",
    "EmailOrPhone": "E-Mail/Telefon",
    "ReplyMessage": "Nachricht beantworten",
    "Picture": "Bild",
    "Description": "Beschreibung",
    "Reply": "Antworten",
    "Denied": "Abgelehnt",
    "Finished": "Abgeschlossen",
    "Processing": "In Bearbeitung",
    "ReplyContents": "Antwortinhalt",
    "EnterReplyContents": "Bitte Antwortinhalt eingeben",
    "Submit": "Absenden",
    "Back": "Zurück",
    "Process": "Bearbeiten",
    "Administrator": "Administrator",
    "FileExceed": "Maximal 2 Bilder können hochgeladen werden",
    "ReplyEmpty": "Die Antwort darf nicht leer sein!",
    "UserMessageStatusUpdate": "Benutzernachrichtenstatus erfolgreich aktualisiert!",
    "UserMessageReply": "Benutzernachricht erfolgreich beantwortet!",
    "PackUp": "Einklappen",
    "DisablePreview": "Vorschau deaktivieren",
    "DisableUnlock": "Entsperrung deaktivieren",
    "DisableCall": "Anruf deaktivieren",
    "SubmitLimit": "Maximal 5 unbeantwortete Nachrichten können eingereicht werden",
    "DeviceNotOnline": "Das Gerät ist nicht online",
    "UploadImagejpgOrPng": "Bitte laden Sie Bilder mit .jpg oder .png Erweiterung hoch!",
    "ProblemType": "Problemtyp",
    "Question": "Frage",
    "BUG": "FEHLER",
    "Suggestion": "Vorschlag",
    "APPOrPhone": "App/Telefon",
    "Others": "Anderes",
    "Country": "Land",
    "Permissions": "Berechtigungen",
    "PrivateIPC": "Private IPC",
    "PublicIPC": "Öffentliche IPC",
    "PasswordErrorTime": "Das Passwort ist falsch, das Konto wird nach 1 Versuch(en) gesperrt.",
    "AccountLockedTime": "Konto gesperrt, bitte versuchen Sie es in 1 Sekunde(n) erneut.",
    "UserPasswordUnlock": "Passwort entsperren",
    "AddPasswordUnlock": "Passwort entsperren hinzufügen",
    "EditPasswordUnlock": "Passwort entsperren bearbeiten",
    "ConfirmDeletePassword": "Löschen der Passwort-Entsperrungseinstellung bestätigen?",
    "CarPlateSettings": "Kfz-Kennzeichen-Einstellungen",
    "AddCarPlate": "Kfz-Kennzeichen hinzufügen",
    "RemakeName": "Name neu erstellen",
    "CarPlateNumber": "Kfz-Kennzeichen",
    "EditCarPlate": "Kfz-Kennzeichen bearbeiten",
    "ConfirmDeleteCarPlate": "Löschen der Kfz-Kennzeicheneinstellung bestätigen?",
    "CardNameExists": "Der Kartenname existiert bereits.",
    "AutomaticOpeningTimes": "Automatische Öffnungszeiten",
    "LockName": "Schlossname",
    "ModeSelection": "Modusauswahl",
    "MomentaryUnlock": "Kurzzeitige Entsperrung",
    "HoldOpen": "Dauerhaft geöffnet",
    "Sunday": "Sonntag",
    "Monday": "Montag",
    "Tuesday": "Dienstag",
    "Wednesday": "Mittwoch",
    "Thursday": "Donnerstag",
    "Friday": "Freitag",
    "Saturday": "Samstag",
    "SundayShort": "Sonntag",
    "MondayShort": "Mo",
    "TuesdayShort": "Di",
    "WednesdayShort": "Mi",
    "ThursdayShort": "Do",
    "FridayShort": "Fr",
    "SaturdayShort": "Sa",
    "EmailNotificationsFrequent": "Die E-Mail-Benachrichtigungen sind zu häufig.",
    "Plan1": "Plan 1",
    "DaySelection": "Tagesauswahl",
    "All": "Alle",
    "Apply": "Anwenden",
    "SelectionTime": "Zeit auswählen",
    "DeviceNotSupportConfig": "Diese Konfiguration wird vom Gerät nicht unterstützt.",
    "PleaseDaySelection": "Bitte wählen Sie ein Datum aus.",
    "PleaseSelectPlan": "Bitte wählen Sie den Plan zum Öffnen des Schlosses aus.",
    "ApplicationSuccessful": "Anwendung erfolgreich",
    "LiftRelaySettings": "Einstellungen für Aufzugsrelais",
    "LiftEnable": "Aufzug aktivieren",
    "RelayQuantity": "Anzahl der Relais",
    "Relay": "Relais",
    "RelayLimit": "Relay-Nummern unterstützen nur negative Zahlen, Buchstaben oder Ziffern.",
    "AccountNickname": "Konto-Spitzname",
    "RelayQuantityEmpty": "Die Anzahl der Relais darf nicht leer sein.",
    "RelayConfigurationEmpty": "Die Relaiskonfiguration darf nicht leer sein.",
    "RelayLengthLimit": "Die Länge des Relais muss zwischen 1 und 20 Zeichen liegen.",
    "4GStrength": "4G-Stärke",
    "4GProvider": "4G-Anbieter",
    "FloorNumber": "Etagennummer",
    "FloorNumberLengthLimit": "Die Etagennummer darf nur aus Buchstaben oder Zahlen bestehen und muss zwischen 1 und 20 Zeichen lang sein.",
    "PleaseConfigLiftRelay": "Bitte konfigurieren Sie zuerst die Aufzugsrelais-Einstellung.",
    "PleaseSelectFloorNumber": "Bitte wählen Sie die Etagennummer aus.",
    "APPUnlockPermission": "In-App-Zugriffskontrollrollen",
    "CarPlateUnlock": "Entsperrung per Autokennzeichen",
    "QRCodeUnlock": "Entsperrung per QR-Code",
    "UnlockPasswordEmpty": "Das Entsperrpasswort darf nicht leer sein.",
    "LockTemplate": "Sperren",
    "QRCode": "QR-Code",
    "ShareQRCode": " Teilen Sie den QR-Code zum Entsperren mit Ihren Freunden, scannen Sie ihn vor dem Türtelefon, um die Tür zu entsperren.",
    "DownloadTemplate": "Herunterladen",
    "AddQRCodeUnlock": "QR-Code zum Entsperren hinzufügen",
    "EditQRCodeUnlock": "QR-Code zum Entsperren bearbeiten",
    "ConfirmDeleteQRCode": "Möchten Sie die Einstellung zum Entsperren per QR-Code löschen?",
    "AddFaceUnlock": "Gesichtserkennung hinzufügen",
    "FaceRecord": "Gesichtsaufzeichnung",
    "UnableAccessCamera": "Auf die Kamera kann nicht zugegriffen werden. Bitte überprüfen Sie, ob die Kamera richtig angeschlossen ist und ob der Zugriff auf die Kamera erlaubt ist.",
    "FaceModelFailedLoad": "Das Gesichtserkennungsmodell konnte nicht geladen werden.",
    "CameraSuccessActivated": "Kamera wurde erfolgreich aktiviert",
    "PleaseTurnOnCamera": "Bitte schalten Sie zuerst die Kamera ein",
    "FaceDetectionModelNotLoaded": "Das Gesichtserkennungsmodell wurde noch nicht vollständig geladen.",
    "PhotoInspectionFailed": "Fotoüberprüfung fehlgeschlagen",
    "PleaseTakePhotoOrUploadPicture": "Bitte machen Sie ein Foto oder laden Sie ein Bild Ihres Gesichts hoch.",
    "FaceDetectionFailed": "Gesichtserkennung fehlgeschlagen",
    "ValidatingImage": "Bild wird überprüft",
    "ImageValiditedSuccessfully": "Bild erfolgreich überprüft!",
    "ImageValiditedFailed": "Bildüberprüfung fehlgeschlagen!",
    "Retry": "Wiederholen",
    "UnlockQRCode": "QR-Code entsperren",
    "ClickToDisplay": "Zum Anzeigen klicken",
    "ClickToCapture": "Zum Erfassen klicken",
    "ConfirmDeleteFaceUnlockSetting": "Möchten Sie die Gesichtserkennungseinstellung löschen?",
    "UnlockFace": "Gesicht entsperren",
    "ShareManagement": "Freigabeverwaltung",
    "ShareAccount": "Freigabekonto",
    "Alias": "Freigegeben für",
    "WantToShare": "Bitte geben Sie das Konto ein, für das Sie die Freigabe wünschen.",
    "ScanQRCodeFriend": "Lassen Sie Ihre Freunde den unten stehenden QR-Code mit der AES Opyn-App scannen, um auf das freigegebene Gerät zuzugreifen.",
    "Link": "Link",
    "FriendsFamily": "Freunde und Familie nicht dabei? Versuchen Sie es mit",
    "ShareLink": "Link teilen",
    "AccountNnumberEmpty": "Die Kontonummer darf nicht leer sein!",
    "ShareSuccess": "Teilen erfolgreich",
    "PendingAcceptance": "Warten",
    "Ignored": "Ignoriert",
    "Rejected": "Abgelehnt",
    "SharerHasDeleted": "Der Teiler hat den Inhalt gelöscht",
    "UserHasShared": "Dieser Benutzer wurde geteilt",
    "CannotSharedOneself": "Kann nicht mit sich selbst geteilt werden",
    "SendSharingMessage": "Teilenachricht senden",
    "ConfirmDeleteShare": "Löschen der Freigabe bestätigen?",
    "NameExists": "Der Name existiert bereits. ",
    "CardNumberExceedDigits": "Die Länge der Kartennummer darf 10 Ziffern nicht überschreiten!",
    "ReInvite": "Erneut einladen",
    "InvitationDetail": "Einladungsdetails",
    "Resend": "Erneut senden",
    "EmailSendSuccess": "Die E-Mail wurde erfolgreich gesendet",
    "DeleteSiteUser": "Möchten Sie den aktuellen Benutzer wirklich löschen? Die zugehörige Lizenz wird ebenfalls gelöscht!",
    "BatchImportOrExport": "Batch-Import",
    "ImportField": "Importieren",
    "ExportField": "Exportieren",
    "ExportTip": "Möchten Sie die Standard-Excel-Datei wirklich zur Konfiguration auf den lokalen Computer exportieren?",
    "ImportedSuccess": "Alle Daten wurden erfolgreich importiert!",
    "ImportedNotAllSuccessful": "98 erfolgreich, 2 fehlgeschlagen. Bitte klicken Sie unten auf die Schaltfläche \"Herunterladen\", um die Daten zu überprüfen und erneut zu importieren.",
    "DataSync": "Datensynchronisierung",
    "UploadFilexls": "Die hochzuladende Datei muss die Dateiendung .xlsx oder .xls haben.",
    "Reverse": "Umkehren",
    "PleaseSelectSiteOrBlocks": "Bitte wählen Sie eine Website oder einen Block aus.",
    "OriginalPrice": "Originalpreis",
    "ExportImportFieldUser": "Diese Funktion soll Installateuren das Importieren von Zieldaten erleichtern. Bitte verwenden Sie vor jedem Batch-Importvorgang die Funktion \"Exportieren\" und lesen Sie die Hinweise zur Verwendung in der Tabelle sorgfältig durch.",
    "ExportImportFieldCard": "Diese Funktion soll Installateuren das Importieren von Zieldaten erleichtern. Bitte verwenden Sie vor jedem Batch-Importvorgang die Funktion \"Exportieren\" und lesen Sie die Hinweise zur Verwendung in der Tabelle sorgfältig durch.",
    "PasswordUnlockLimit": "Das Passwort muss zwischen 4 und 12 Zeichen lang sein.",
    "DeviceDataDuplication": "Gerätedaten duplizieren",
    "CurrentNumberApartmentMax": "Die aktuelle Anzahl der Apartment-Freigaben hat ihr Maximum erreicht. Bitte löschen Sie einige und versuchen Sie es erneut.",
    "ApartmentNumberExist": "Dieser Apartment-Code wird bereits verwendet. Bitte wählen Sie einen anderen Code.",
    "AddOnePanelUse": "Bitte fügen Sie mindestens ein Panel zum Standort oder Block hinzu, bevor Sie diese Funktion verwenden.",
    "GuardMaximumLimit": "Die Anzahl der Wachleute hat die maximale Grenze erreicht.",
    "Importing": "Importieren ...",
    "ParkingCardNumber": "Parkkartennummer",
    "ParkingCardNumberLimit": "Die Parkkartennummer muss eine Dezimalzahl zwischen 1 und 16.777.215 sein!",
    "ParkingCardNumberExists": "Parkkartennummer existiert bereits",
    "GeneralSettings": "Allgemeine Einstellungen",
    "RFID": "RFID",
    "CarPlate": "Autokennzeichen",
    "WiegandInput": "Wiegand-Eingabe",
    "PlateNumberExists": "Das Autokennzeichen existiert bereits.",
    "PlateNumberEmpty": "Die Kfz-Kennzeichen-Nummer muss zwischen 1 und 64 Zeichen lang sein.",
    "LimitUnlockNumLimit": "Die Begrenzungsanzahl muss eine Zahl sein und sollte mindestens 1 und höchstens 999 betragen.",
    "ChangeAssessStatusDesc": "Bitte beachten Sie, dass die Freischaltdaten für dieses Panel erneut manuell angekreuzt werden müssen.",
    "ImportPrompt": "Import",
    "ExportPrompt": "Export",
    "CreateNewDevice": "Neues Gerät erstellen",
    "DeviceType": "Gerätetyp",
    "AccessControlTerminal": "Tastatur",
    "PleaseSelectDeviceType": "Bitte wählen Sie den Gerätetyp aus",
    "DeviceSerialNumberEmpty": "Die Seriennummer des Geräts darf nicht leer sein",
    "DeviceSecurityNumberEmpty": "Der Sicherheitscode des Geräts darf nicht leer sein",
    "DeviceNameEmpty": "Der Gerätename darf nicht leer sein",
    "DeviceNameLimitNew": "Der Gerätename muss zwischen 1 und 30 Zeichen enthalten",
    "DeviceSerialLimitNew": "Die Seriennummer des Panels muss zwischen 1 und 20 Zeichen enthalten",
    "DeviceSecurityCodeLimitNew": "Der Sicherheitscode des Panels muss zwischen 1 und 64 Zeichen enthalten",
    "DeviceSerialNumber": "Geräte-Seriennummer *",
    "DeviceSecurityCode": "Gerätesicherheitscode *",
    "Error": "Fehler",
    "DeviceTypeError": "Das hinzugefügte Gerät stimmt nicht mit dem ausgewählten Modell überein. Bitte verwenden Sie das richtige Gerät zum Hinzufügen!",
    "CreateNewACT": "Neues Tastatur erstellen",
    "BluetoothVersion": "Bluetooth-Version",
    "MCUVersion": "MCU-Version",
    "BluetoothMac": "BLE-MAC-Adresse",
    "IPAddress": "IP-Adresse",
    "DeviceStatus": "Gerätestatus",
    "DeviceLog": "Geräteprotokoll",
    "MasterCode": "Mastercode",
    "RelayActivationTime": "Relais-Aktivierungszeit",
    "ButtonBeep": "Signalton der Taste",
    "HoldOpen": "Dauerhaft geöffnet",
    "ExitButtonUnlockTime": "Entriegelungszeit der Ausgangstaste",
    "ToneVolume": "Lautstärke des Signaltons",
    "TamperAlarm": "Sabotagealarm",
    "ContinuousInputErrorProtection": "Schutz vor wiederholten Eingabefehlern",
    "TimeZone": "Zeitzone",
    "OFF": "AUS",
    "ON": "EIN",
    "MaterCodeLimit": "Die Passwortlänge muss zwischen 6 und 12 Ziffern liegen.",
    "RelayActivationTimeLimit": "Die Relais-Aktivierungszeit muss eine Zahl zwischen 1 und 99 sein und darf nicht mit 0 beginnen.",
    "UnlockBluetooth": "Bluetooth-Entriegelung",
    "UnlockFingerPrint": "Fingerabdruck-Entriegelung",
    "WiegandUnlock": "Wiegand-Entriegelung",
    "DeviceDetail": "Gerätedetails",
    "BindingDevice": "Gerät verbinden",
    "UpdateDevice": "Gerät aktualisieren",
    "UnbindingDevice": "Gerät trennen",
    "ConfirmUnbindDevice": "Trennen des Geräts bestätigen?",
}